export const SIDEBAR_COLLAPSED_LS_KEY = 'ggj.b2c.sidebar.collapsed';

/** Desktop default: collapsed until the user expands the rail. */
export function readSidebarCollapsed(): boolean {
  if (typeof window === 'undefined') return true;
  if (window.innerWidth < 1024) return true;
  try {
    const v = localStorage.getItem(SIDEBAR_COLLAPSED_LS_KEY);
    if (v === 'true') return true;
    if (v === 'false') return false;
  } catch { /* ignore */ }
  return true;
}

/** Fresh login lands with the sidebar collapsed; user choice persists after expand. */
export function collapseSidebarForPostLogin(): void {
  try {
    localStorage.setItem(SIDEBAR_COLLAPSED_LS_KEY, 'true');
  } catch { /* ignore */ }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(
      new CustomEvent('ggj:workspace-sidebar', { detail: { collapsed: true } }),
    );
  }
}
